import React from "react";
import MenuButton from "./MenuButton";
import "../../css/menu.css";
import AbstractMenu from "./AbstractMenu";
import SubmenuHeader from "./SubMenuHeader";
import { Route, Switch } from "react-router-dom";
import SuperRestaurantAdmin from "../../superadmin/superRestaurantAdmin/SuperRestaurantAdmin";
import { connect } from "react-redux";
import SuperUserAdmin from "../../superadmin/superUserAdmin/SuperUserAdmin";
import auth, { get } from "../../js/auth";
import PaymentMethods from "../../superadmin/paymentMethods/PaymentMethods";
import admin from "../../js/admin";
import AI from "../../admin/AI/AI";
import { CanAccess } from "../CanAccess";
import icon from "../../img/anydesk.png";
import PrinterServerBrowser from "../../superadmin/printerServerBrowser/PrinterServerBrowser";



class SuperAdminMenus extends AbstractMenu {

  componentWillUnmount = () => {
    admin.getMyStatus(() => { });
  }

  render() {
    const { admin_local } = this.props;
    const superAdminBackground = "#847556";
    if (admin_local)
      return (
        <React.Fragment>
          <CanAccess action="menu" type="menu" resource="superAdminMenus/">
            <Switch>
              <Route path={"/superAdminMenus/superRestaurantAdmin"} render={props => <SuperRestaurantAdmin {...props} />} />
              <Route
                exact
                path={"/superAdminMenus"}
                render={props => (
                  <div className="mainMenuWrap" style={{ flexGrow: 1, display: "flex", flexFlow: "column" }}>
                    <SubmenuHeader {...this.props} header={admin_local.menus.superAdminMenu} />
                    <div className="mainMenuGrid" style={{ flexGrow: 1 }}>
                      <MenuButton backgroundImage={require("../../img/menu-new/shopping-bag.svg")} href={"superAdminMenus/superRestaurantAdmin"} id="restaurants" background={superAdminBackground} name={admin_local.menus.restaurants} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/users.svg")} href={"superAdminMenus/superUserAdmin"} id="users" background={superAdminBackground} name={admin_local.menus.users} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-percent.svg")} onClick={() => this.navigate("superadmin_currencies.html")} id="currencies" background={superAdminBackground} name={admin_local.menus.currencies} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-bank-terminal.svg")} href={"superAdminMenus/paymentMethods"} id="paymentMethods" background={superAdminBackground} name={admin_local.menus.paymentMethods} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/bar-chart-2.svg")} onClick={() => this.navigate("superadmin_reports.html")} id="reports" background={superAdminBackground} name={admin_local.menus.manage_reports} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/monitor.svg")} onClick={() => this.navigate(auth.server + "/eatwithme.server/monitoring")} id="monitoring" background={superAdminBackground} name={admin_local.menus.monitoring} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-tag.svg")} onClick={() => get("superadminService/sendResellerFees")} id="sendResellerFees" background={superAdminBackground} name={admin_local.menus.send_reseller_fees} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-tag.svg")} onClick={() => get("superadminService/sendResellerFeesToMe")} id="sendResellerFeesToMe" background={superAdminBackground} name={admin_local.menus.send_reseller_fees_to_me} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/activity.svg")} onClick={() => get("superadminService/checkSubscriptions")} id="checkSubscriptions" background={superAdminBackground} name={admin_local.menus.check_subscriptions} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/settings.svg")} onClick={() => get("superadminService/reloadConsole")} id="reloadConsole" background={superAdminBackground} name={admin_local.reload_console} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/update.svg")} onClick={() => get("superadminService/reloadKiosks")} id="reloadKiosks" background={superAdminBackground} name={admin_local.refresh_kiosks} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/grid.svg")} onClick={() => get(`superadminService/${localStorage.restaurantSelected}/updateSupersetSchema`)} id="syncSuperset" background={superAdminBackground} name={admin_local.sync_superset} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/monitor.svg")} href={"superAdminMenus/printerServerBrowser"} id="printerServerBrowser" background={superAdminBackground} name={admin_local?.menus?.printer_server_browser || "Printer server browser"} myStatus={this.props.myStatus} />
                      <MenuButton backgroundImage={require("../../img/menu-new/message-circle.svg")} href={"superAdminMenus/ai"} id="ai" background={superAdminBackground} name={admin_local.ai} myStatus={this.props.myStatus} />
                      <CanAccess resource="superAdminMenus/">
                        {auth.device.platform === "browser" && this.props.anydesk && this.props.anydesk.map(item => (
                          <MenuButton
                            href={`anydesk-connect://${item.id}?name=${item.name}}`}
                            id={`anydesk-${item.id}`}
                            backgroundImage={icon}
                            name={item.name}
                            myStatus={this.props.myStatus} />
                        ))}
                        {auth.device.platform === "iOS" && this.props.anydesk && this.props.anydesk.map(item => (
                          <MenuButton
                            href={`anydesk://${item.id}`}
                            id={`anydesk-${item.id}`}
                            backgroundImage={icon}
                            name={item.name} myStatus={this.props.myStatus} />
                        ))}
                      </CanAccess>

                    </div>
                  </div>
                )}
              />
              <Route path={"/superAdminMenus/superUserAdmin"} render={props => <SuperUserAdmin {...props} />} />
              <Route path={"/superAdminMenus/paymentMethods"} render={props => <PaymentMethods {...props} />} />
              <Route exact path={"/superAdminMenus/printerServerBrowser"} render={props => <PrinterServerBrowser {...props} />} />
              <Route exact path={"/superAdminMenus/printerServerBrowser/:printerServer"} render={props => <PrinterServerBrowser {...props} />} />
              <Route path={"/superAdminMenus/ai"} render={props => <AI {...props} />} />
              <Route path={"/superAdminMenus/:printerServer"} render={props => {
                if (props.match.params.printerServer === "printerServerBrowser") {
                  return null;
                }
                return <PrinterServerBrowser {...props} />;
              }} />
            </Switch>
          </CanAccess>
        </React.Fragment>
      );
    else return null;
  }
}

const mapStateToProps = state => {
  return {
    admin_local: state.rootReducer.admin_local,
    local: state.rootReducer.local,
    anydesk: state.rootReducer.myStatus?.restaurant_settings?.["enabled-features"]?.anydesk

  };
};

export default connect(mapStateToProps)(SuperAdminMenus);
